import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const Hero = () => {
  const { t } = useTranslation();
  return (
    <section id="home" className="bg-gradient-to-r from-primary to-purple1 text-white py-24">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
        <motion.div initial={{ x:-50, opacity:0 }} animate={{ x:0, opacity:1 }} transition={{ duration:0.6 }} className="flex-1">
          <h1 className="font-poppins text-4xl md:text-5xl">{t('hero.title')}</h1>
          <p className="mt-4 text-lg max-w-xl">{t('hero.tagline')}</p>
          <div className="mt-6 flex gap-3">
            <a href="mailto:marleyrozo@gmail.com" className="px-4 py-2 rounded-md bg-purple1 hover:scale-105 transition">{t('hero.cta')}</a>
            <a href="https://github.com/yerikamarley" target="_blank" rel="noreferrer" className="px-4 py-2 rounded-md border">GitHub</a>
          </div>
          <div className="mt-4 text-sm">
            <div>Email: marleyrozo@gmail.com</div>
            <div>Tel: +57 3142035583</div>
            <div>Ubicación: Cúcuta N.S. - Colombia</div>
            <div className="mt-2"><a href="https://www.linkedin.com/in/yerika-marley-basto-rozo-605354150/" target="_blank" rel="noreferrer">LinkedIn</a></div>
          </div>
        </motion.div>

        <motion.div initial={{ scale:0.9, opacity:0 }} animate={{ scale:1, opacity:1 }} transition={{ duration:0.6 }} className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden ring-4 ring-white">
          {/* Placeholder photo description */}
          <img src="https://i.postimg.cc/G3JsqJWk/Whats-App-Image-2025-11-01-at-2-26-01-PM.jpg" alt="Yerika Marley - foto profesional" className="object-cover w-full h-full" />
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
